export default "__VITE_ASSET__CBIp$n7u__"